import { Stack, Text } from '@sixui/ui';
import stylex from '@stylexjs/stylex';
import { useTranslation } from 'react-i18next';

import type { IContainerProps } from '~/components/utils/Container';
import { ColorSchemeSwitch } from '~/components/organisms/fields/ColorSchemeSwitch';
import { DensitySwitch } from '~/components/organisms/fields/DensitySwitch';
import { LanguageSelector } from '~/components/organisms/fields/LanguageSelector';

export type IFooterCopyrightSectionProps = IContainerProps;

const styles = stylex.create({
  languageSelector: {
    flexGrow: 0,
  },
  actions: {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0,
    justifyContent: 'flex-end',
  },
});

export const FooterCopyrightSection: React.FC<IFooterCopyrightSectionProps> = (
  props,
) => {
  const { sx } = props;
  const { t } = useTranslation();

  return (
    <Stack as="section" horizontal gap={6} sx={sx} justify="space-between">
      <Stack gap={1}>
        <p>{t('FooterCopyrightSection.copyright')}</p>
        <Text variant="label" size="sm">
          v.{__COMMIT_SHA__}
        </Text>
      </Stack>
      <Stack horizontal gap={4}>
        <DensitySwitch />
        <ColorSchemeSwitch />
        <LanguageSelector sx={styles.languageSelector} />
      </Stack>
    </Stack>
  );
};
